import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}/accounts/index.php`;

export const paymentService = {
    getPaymentInfo,
    getGroupInfo,
    getPaymentGroup,
    getUPaymentGroup,
};

async function getPaymentInfo(paymentID) {
    return await axios.get(`${baseURL}?type=2&paymentID=${paymentID}`)
        .then(response => response.data)
        .catch(err => console.log(err));
}

async function getGroupInfo(paymentID) {
    return await axios.get(`${baseURL}?type=2&paymentID=${paymentID}`)
        .then(response => response.data)
        .catch(err => console.log(err));
}

async function getPaymentGroup(paymentID){
    console.log(paymentID);
    return await axios.get(`${baseURL}?type=3&paymentID=${paymentID}`)
        .then(response => response.data)
        .catch(err => console.log(err));
}

async function getUPaymentGroup(paymentID){
    console.log(paymentID);
    return await axios.get(`${baseURL}?type=5&paymentID=${paymentID}`)
        .then(response => response.data)
        .catch(err => console.log(err));
}